import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import UserBadge from "~/modules/user/components/UserBadge";

export function RouteDetailPanelTimelineFieldworkerActivity({
    firstName,
    lastName,
    activityKey,
    profilePictureMediaUrl,
}: {
    firstName: string;
    lastName: string;
    profilePictureMediaUrl?: string | null;
    activityKey: "departs" | "arrives" | "isPickedUp" | "isDroppedOff";
}) {
    const { t } = useTranslation("plannerV2");
    return (
        <Stack direction="row" columnGap={1}>
            <UserBadge size={24} names={[firstName, lastName]} profilePicture={profilePictureMediaUrl} />
            <Typography>{t(`routeActivity.${activityKey}`, { name: `${firstName} ${lastName}` })}</Typography>
        </Stack>
    );
}
